import { Button, Checkbox, Form, FormProps, Input, notification } from "antd";
import React, { useState } from "react";
import { signIn } from "../actions";
import { useUser } from "../../../DataProvider";

export type SignInFieldType = {
  username: string;
  password: string;
  remember?: boolean;
};
const SignInForm = () => {
  const { login } = useUser();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish: FormProps<SignInFieldType>["onFinish"] = async (values) => {
    setIsLoading(true);
    const { success, message, token, user } = await signIn(values);
    if (success) {
      login(user!, token!);
      api.info({
        message: `Signed In Successfully`,
        description: "You will be redirected to the dashboard",
      });
    } else {
      api.info({
        message: `Signed In Failed`,
        description: message,
      });
      setIsLoading(false);
    }
  };
  const onFinishFailed: FormProps<SignInFieldType>["onFinishFailed"] = (
    errorInfo
  ) => {};
  return (
    <>
      {contextHolder}
      <Form
        className=" mt-5"
        name="basic"
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item<SignInFieldType>
          name="username"
          rules={[{ required: true, message: "Please input your username!" }]}
        >
          <Input type="email" placeholder="Username" />
        </Form.Item>

        <Form.Item<SignInFieldType>
          name="password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>

        <Form.Item<SignInFieldType>
          name="remember"
          valuePropName="checked"
          label={null}
        >
          <Checkbox>Remember me</Checkbox>
        </Form.Item>

        <Form.Item label={null}>
          <Button type="primary" loading={isLoading} htmlType="submit">
            {isLoading ? "Signing In" : "Sign In"}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SignInForm;
